import { render, staticRenderFns } from "./verify_account.vue?vue&type=template&id=27fd921b&scoped=true&"
import script from "./verify_account.vue?vue&type=script&lang=js&"
export * from "./verify_account.vue?vue&type=script&lang=js&"
import style0 from "./verify_account.vue?vue&type=style&index=0&id=27fd921b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd921b",
  null
  
)

export default component.exports